/* tslint:disable:variable-name */
import {MasterService} from './../../services/master.service';
import {ReportModalComponent} from './../../../shared/report-modal/report-modal.component';
import {Component, OnInit ,Input, Output, EventEmitter} from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {AutofillMonitor} from '@angular/cdk/text-field';
import {StockService} from '../../services/stocks.service';
import {PaginationInstance} from 'ngx-pagination';
import {DeleteModalService} from '../../services/delete-modal.service';
import { PageEvent } from '@angular/material/paginator';
import {CommonAlertService} from "../../../services/common-alert.service";

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {
  public filter: any;
  public report: any;
  // tslint:disable-next-line:variable-name
  total_count: number;
  // tslint:disable-next-line:variable-name
  current_page: number;
  // tslint:disable-next-line:variable-name
  last_page: number;
  // tslint:disable-next-line:variable-name
  per_page: number;
  stockPageId = 'stockPageId';
  pageEvent: PageEvent;
  paginationID = 'listing_pagination';
  public selectedIndex = 0;
  public searchBy: any = 0;
  public searchTxt: any;
  public successMsg: any;
  placeHolder: any = 'Search By First  Name';
  @Input() id: string;
  @Input() maxSize: number;
  @Output() pageChange: EventEmitter<number>;
  itemToBePushed: any;

  public config: PaginationInstance = {
    id: 'custom',
    itemsPerPage: 10,
    currentPage: 1
  };
  //public childMessage = 'listing_pagination';
  bool = false;
  public viewPermission = false;
  public addPermission = false;
  public editPermission = false;
  public deletePermission = false;
  // tslint:disable-next-line:max-line-length
  constructor(public dialog: MatDialog, public stockService: StockService, public masterService: MasterService, public deleteModalService: DeleteModalService, public commonAlertService: CommonAlertService) {
  }
  ngOnInit() {
    // @ts-ignore
    // tslint:disable-next-line:triple-equals
    if (localStorage.getItem('roleId') == 0) {
      // @ts-ignore
      // tslint:disable-next-line:max-line-length
      this.viewPermission = this.addPermission = this.editPermission = this.deletePermission = true;
    } else {
      const roles = JSON.parse(localStorage.getItem('roles'));
      // tslint:disable-next-line:triple-equals max-line-length
      if (roles['more.report.view'] == 1 || roles['more.report.add'] == 1 || roles['more.report.edit'] == 1 || roles['more.report.delete'] == 1) {
        this.viewPermission = true;
      }
      // tslint:disable-next-line:triple-equals
      if (roles['more.report.add'] == 1) {
        this.addPermission = true;
      }
      // tslint:disable-next-line:triple-equals
      if (roles['more.report.edit'] == 1) {
        this.editPermission = true;
      }
      // tslint:disable-next-line:triple-equals
      if (roles['more.report.delete'] == 1) {
        this.deletePermission = true;
      }
    }
    this.filter = {
      token: localStorage.getItem('token')
    };
    this.getData();
  }
  getData() {
    this.masterService.getIndex('/user_roles/getreportlist', this.filter).subscribe(res => {
      // @ts-ignore
      this.report = res.data.items;
      // @ts-ignore
      this.total_count = res.data.total;
      // @ts-ignore
      this.last_page = res.data.last_page;
      // @ts-ignore
      this.per_page = res.data.per_page;
      this.itemToBePushed = (this.last_page * this.per_page) - this.total_count;
      this.total_count = this.total_count + (this.last_page * this.per_page - this.total_count);
      // @ts-ignore
      this.current_page = res.data.current_page;
      this.bool = true;
      const newData = {
        id: '',
        name: ''
      };
      // @ts-ignore
      
      if (this.report.length < 10) {
        for ( let i = this.report.length; i < 9 ; i++) {
        //for ( let i = 0; i < 9 ; i++) {
          this.report.push(newData);
        }
      }
      // @ts-ignore
      if(res.data.total == 0){ 
       this.commonAlertService.showEmptyMsg({message: 'No Details Found.'})
      }
    });
  }
  getSearchValue() {
    if (this.searchBy) {
      switch (this.searchBy) {
        case '0':
          this.placeHolder = 'Search By Report Name';
          break;
          case '1':
          this.placeHolder = 'Search By Report Name';
          break;
        default: this.placeHolder = 'Search By Report Name';
      }
    }
  }

  openDialog() {
    const dialogRef = this.dialog.open(ReportModalComponent, {
//      minHeight: '500px',
      minWidth: '50vw',
      disableClose: true,
      autoFocus: true
    }).afterClosed().subscribe(() => this.getData());
  }
  editDialog(index, type) {
    const showForm = type;
    const editId = this.report[index].id;
    const encID = localStorage.getItem('token');
    // tslint:disable-next-line:triple-equals
    if ( editId != undefined && encID != undefined) {
      const dialogRef = this.dialog.open(ReportModalComponent, {
        minWidth: (showForm === 'edit') ? '50vw' : '30vw',
        disableClose: true,
        data: {
          id: editId,
          enc_Id: encID,
          type: showForm
        }
      }).afterClosed().subscribe(() => this.getData());
    } 
  }
  // Delete the purchase order
  deleteDialog(i): void {
    this.successMsg = 'The Record is deleted successfully';
    this.deleteModalService.openModal({
      id: this.report[i].id,
      encId: localStorage.getItem('token'), 
      deleteUrl: '/user_roles/deletereport'
    });

    this.deleteModalService.closed.subscribe(() => {
       
      this.commonAlertService.showEdit({message: this.successMsg});
      this.getData();
    });
  }

  selectRow(index: number) {
    this.selectedIndex = index;
  }

  openEditDialog(index): void {
    const editId = this.report[index].id;
    const encID = localStorage.getItem('token');
    // this.masterService.getRecordById();

    // tslint:disable-next-line:triple-equals
    if (editId != undefined && encID != undefined) {
      const dialogRef = this.dialog.open(ReportModalComponent, {
        minWidth: '50vw',
        disableClose: true,
        data: {
          id: editId,
          enc_Id: encID,
          type: 'edit'
        }
      }).afterClosed().subscribe(() => this.getData());
    }

  }

  doSearch(): void {

  if (this.searchBy != null) {
      switch (this.searchBy) {
         case '0':
           Object.assign(this.filter, {search: { type: 'str', field: 'report_master.name', text: this.searchTxt}});
           break;
           case '1':
           Object.assign(this.filter, {search: { type: 'str', field: 'report_master.type', text: this.searchTxt}});
           break;
         default:
           Object.assign(this.filter, {search: { type: 'str', field: 'report_master.name', text: this.searchTxt}});
      }
    }
  this.getData();
  }

  doRefresh(): void {
     this.searchTxt = null;
     this.filter = {
       token: localStorage.getItem('token')
     };
     this.getData();
  }

  doPaginate(e): void {
    Object.assign(this.filter, {page: e});
    this.getData();
  }
}



